import { noop } from '@mail-core/std';
import type { PayloadAction } from '@reduxjs/toolkit';
import {
    closeUnlimitedDocumentsModal,
    renderUnlimitedDocumentsModal,
} from 'reactApp/ui/UnlimitedDocuments/UnlimitedDocumentsModal/UnlimitedDocumentsModal.helpers';
import {
    closeUnlimitedDocumentsThanksModal,
    preloadUnlimitedDocumentsThanksModalCover,
    renderUnlimitedDocumentsThanksModal,
} from 'reactApp/ui/UnlimitedDocuments/UnlimitedDocumentsThanksModal/UnlimitedDocumentsThanksModal.helpers';
import { channel } from 'redux-saga';
import { take, takeEvery } from 'redux-saga/effects';

import { type BuyUnlimitedDocumentsTariffType, UnlimitedDocumentsActions } from './unlimitedDocuments.module';

export function* handleBuyUnlimitedDocumentsTariff(action: PayloadAction<BuyUnlimitedDocumentsTariffType>) {
    const { onClose = noop, onCancel = noop, onClick = noop, onShow = noop, type, stage, offer_source } = action?.payload;

    const flowChannel = channel<boolean>();

    preloadUnlimitedDocumentsThanksModalCover();

    if (stage === 'start') {
        renderUnlimitedDocumentsModal({
            onClick: () => {
                flowChannel.put(true);
                onClick();
                closeUnlimitedDocumentsModal();
            },
            onClose: () => {
                flowChannel.close();
                onClose();
            },
            onShow,
            onCancel,
            type,
            offer_source,
        });
    } else {
        flowChannel.put(true);
    }

    const flowStepSuccess = yield take(flowChannel);
    if (!flowStepSuccess) {
        return;
    }

    renderUnlimitedDocumentsThanksModal({
        onClick: () => {
            closeUnlimitedDocumentsThanksModal();
        },
        offer_source,
    });
}

export function* watchUnlimitedDocuments() {
    yield takeEvery(UnlimitedDocumentsActions.buyUnlimitedDocumentsTariff.toString(), handleBuyUnlimitedDocumentsTariff);
}
